import './index.css';
import ReactDOM from 'react-dom/client';
// import "react-datepicker/dist/react-datepicker.css";
import {BrowserRouter} from "react-router-dom";
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);